import { User } from '@livv/models';
import { isInternalUser } from '@livv/utils/helpers';
import { UserPrivileges } from '@models/users';

export enum UserNotConnectedPropertiesName {
    IS_CONNECTED = 'is_connected',
}

export enum UserConnectedPropertiesName {
    EMAIL = 'email',
    IS_ADMIN = 'is_admin',
    IS_INTERNAL = 'is_internal',
    IS_CONNECTED = 'is_connected',
    IS_PAID = 'is_paid',
    IS_TRIAL = 'is_trial',
    EXPIRED_TRIAL = 'expired_trial',
}

type UserConnectedBooleanProperties = Record<
    Exclude<UserConnectedPropertiesName, UserConnectedPropertiesName.EMAIL>,
    boolean
>;
type UserConnectedProperties = UserConnectedBooleanProperties &
    Record<UserConnectedPropertiesName.EMAIL, string>;
type UserNotConnectedProperties = Record<UserNotConnectedPropertiesName, boolean>;
export type UserProperties = UserConnectedProperties | UserNotConnectedProperties;

export const processUserNotConnectedProperties = (): UserNotConnectedProperties => {
    return {
        [UserNotConnectedPropertiesName.IS_CONNECTED]: false,
    };
};

export const processUserConnectedProperties = (
    userInfo: User,
    userPrivileges: UserPrivileges,
): UserConnectedProperties => {
    const email = userInfo.email.trim().toLowerCase();
    const { isPaidCustomer, role, trialEndDate } = userPrivileges;

    return {
        [UserConnectedPropertiesName.EMAIL]: email,
        [UserConnectedPropertiesName.IS_CONNECTED]: true,
        [UserConnectedPropertiesName.IS_ADMIN]: role === 'admin',
        [UserConnectedPropertiesName.IS_PAID]: isPaidCustomer,
        [UserConnectedPropertiesName.IS_INTERNAL]: role === 'user' && isInternalUser(email),
        [UserConnectedPropertiesName.EXPIRED_TRIAL]: trialEndDate
            ? trialEndDate > Date.now()
            : false,
        [UserConnectedPropertiesName.IS_TRIAL]: !isPaidCustomer,
    };
};
